var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8018_2460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9994 18.3303C4.55744 18.3303 4.13359 18.1547 3.82108 17.8422C3.50857 17.5297 3.33301 17.1059 3.33301 16.6639V3.33278C3.33301 2.89082 3.50857 2.46697 3.82108 2.15446C4.13359 1.84195 4.55744 1.66638 4.9994 1.66638H11.665C11.9287 1.66596 12.1899 1.71771 12.4336 1.81867C12.6773 1.91962 12.8986 2.06778 13.0847 2.25462L16.0742 5.24413C16.2616 5.43035 16.4102 5.65185 16.5114 5.89582C16.6127 6.13979 16.6646 6.40141 16.6641 6.66556V16.6639C16.6641 17.1059 16.4886 17.5297 16.1761 17.8422C15.8636 18.1547 15.4397 18.3303 14.9977 18.3303H4.9994Z",
    stroke: "#5D5D5D",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6646 1.66638V5.83236C11.6646 6.05334 11.7523 6.26526 11.9086 6.42152C12.0648 6.57777 12.2768 6.66556 12.4977 6.66556H16.6637",
    stroke: "#5D5D5D",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33192 7.49878H6.66553",
    stroke: "#5D5D5D",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3311 10.8315H6.66553",
    stroke: "#5D5D5D",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3311 14.1643H6.66553",
    stroke: "#5D5D5D",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8018_2460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9967,
    height: 19.9967,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTicket);
export default __webpack_public_path__ + "static/media/new_ticket.27a219f2cbb47fcbfd57474ff5212a60.svg";
export { ForwardRef as ReactComponent };